import { Card, Typography as typography_antd } from "antd";
import LeaveStyle from "../../Components/LeavesStyle";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import ErrorIcon from "@mui/icons-material/Error";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./index.css";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { fetchSubLeaveTypeData } from "../../redux/slice/subLeaveType.js";
import { useDispatch, useSelector } from "react-redux";
import "./addemployee.css";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice.js";
import CryptoJS from "crypto-js";

const { default: env } = require("../../config/env.js");
const { Title } = typography_antd;

function formatNumberWithCommas(number) {
  const parts = number.toLocaleString("en-IN").split(".");

  const formatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  });

  const formattedNumber =
    parts.length === 2 ? formatter.format(parts[0]) + "." + parts[1] : parts[0];
  return formattedNumber;
}
const AddEmployee = () => {
  const navigate = useNavigate();

  const nameRegex = /^[A-Za-z ]+$/;
  const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
  const designationRegex = /^[A-Za-z ]+$/;

  const [roleData, setRoleData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectVal, setSelectVal] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [subLeaveData, setSubLeaveData] = useState([]);
  const [preventDoubleClick, setpreventDoubleClick] = useState(false);
  const [assignObj, setAssignObj] = useState({});
  const [employeeData, setEmployeeData] = useState({
    name: "",
    designation: "",
    company_email: "",
    role: "",
    salary: "",
    joining_date: "",
    flag: "",
  });
  const [newUserId, setNewUserId] = useState("");
  const [errorText, setErrorText] = useState({
    name: "",
    designation: "",
    company_email: "",
    role: "",
    salary: "",
    joining_date: "",
    flag: "",
  });
  const token = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  // if (state?.getSubLeaveType?.data?.status === 555 || state?.getSubLeaveType?.data?.status === 501) {
  //   dispatch(setToken(null));
  //   dispatch(setUserData(null));
  // toast.error("Session expire, Please LogIn!", {
  //   position: toast.POSITION.TOP_RIGHT,
  //   toastId: "1",
  // });
  //   Navigate("/login")
  // }

  const subLeaveArr = state?.getSubLeaveType?.data?.data;

  useEffect(() => {
    if (token) {
      dispatch(fetchSubLeaveTypeData(token));
    }
  }, [token]);

  useEffect(() => {
    if (subLeaveArr) {
      setSubLeaveData(subLeaveArr);
      let data = {};
      subLeaveArr?.map((val) => {
        let key = val.sub_leave_type_id;
        data = { ...data, [key]: "0" };
      });
      setAssignObj(data);
    }
  }, [subLeaveArr]);

  useEffect(() => {
    getRoleData(token);
  }, []);

  const getRoleData = async () => {
    try {

      const getRole = CryptoJS.SHA256("/getRole" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

      const response = await fetch(`${env.backend_api_endpoint}/${getRole}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }

      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200 && successData.data) {

          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          setRoleData(decryptedData);
        }
      }
    } catch (error) {
      console.error("Error Roles in:", error.message);
    }
  };

  const handleChange = (val) => {
    setSelectVal(val);
    setEmployeeData({ ...employeeData, role: val });
  };

  const dateFormate = (date) => {
    const time = date.toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const d = date.toLocaleDateString([], {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    return `${d}, ${time}`;
  };

  const validateForm = () => {
    const errors = {};

    if (!employeeData.name) {
      errors.name = "Name is required!";
    } else if (!nameRegex.test(employeeData.name)) {
      errors.name = "Enter a valid name!";
    }

    if (!employeeData.designation) {
      errors.designation = "Designation is required!";
    } else if (!designationRegex.test(employeeData.designation)) {
      errors.designation = "Enter a valid designation!";
    }

    if (!employeeData.company_email) {
      errors.company_email = "Email is required!";
    } else if (!emailRegex.test(employeeData.company_email)) {
      errors.company_email = "Invalid email address!";
    }

    if (!employeeData.role) {
      errors.role = "Role is required!";
    }
    if (!employeeData.salary) {
      errors.salary = "Employee salary is required!";
    }
    if (!employeeData.joining_date || employeeData.joining_date == "Invalid Date") {
      errors.joining_date = "Joining Date is required!";
    }
    if (!employeeData.flag) {
      errors.flag = "Please select Status!";
    }

    return errors;
  };

  // function generateEmpId() {
  //   // Generate random number between 0 and 999999
  //   const randomNum = Math.floor(Math.random() * 1000000);

  //   // Pad with leading zeros if needed (e.g. 42 → 000042)
  //   const sixDigit = String(randomNum).padStart(6, '0');

  //   // Add EMP prefix
  //   return `EMP${sixDigit}`;
  // }

  // Example usage
  // console.log(generateEmpId()); // EMP123456

  const onFinish = async () => {
    const formErrors = validateForm();
    // const empID = generateEmpId();

    if (Object.keys(formErrors).length === 0) {
      if (!submitting) {
        setSubmitting(true);
        if (
          assignObj?.compensate_leave === "" ||
          assignObj?.lwp_leave === "" ||
          assignObj?.maternity_leave === "" ||
          assignObj?.paid_leave === "" ||
          assignObj?.flag === "" ||
          assignObj?.paternity_leave === ""
        ) {
          toast.error("Please Enter Number In Assign Leave!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
        } else {
          const tempvalue = employeeData.salary?.toLocaleString();
          let salaryValue = parseFloat(tempvalue.replace(/,/g, ""));

          const data = {
            name: employeeData?.name,
            companyEmail: employeeData?.company_email,
            designation: employeeData.designation,
            role: employeeData.role,
            salary: salaryValue,
            activeUser: employeeData.flag === "Active" ? 1 : 0,
            joiningDate: employeeData.joining_date,
            // empId: empID,
          }

          // Encrypt data
          const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

          //Encrypt api endpoint
          const addEmployee = CryptoJS.SHA256("/addEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

          try {
            const response = await fetch(`${env.backend_api_endpoint}/${addEmployee}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: token,
              },
              body: JSON.stringify({ encryptedData: encryptedBody }),
            });

            if (response.ok) {

              const successData = await response.json();

              if (successData.status === 200 && successData.data) {

                // Decrypt backend response
                const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
                const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

                const data = decryptedData;

                if (data?.newUsertoken) {
                  const newUserToken = data?.newUsertoken;
                  sendMail(newUserToken);
                }
                if (data?.newUserId) {
                  assignLeave(data?.newUserId);
                }
              }
              if (!response.ok) {
                const errorData = await response.json();

                if (errorData.status === 555 || errorData.status === 501) {
                  dispatch(setToken(null));
                  dispatch(setUserData(null));
                  toast.error("Session expire, Please LogIn!", {
                    position: toast.POSITION.TOP_RIGHT,
                    toastId: "1",
                  });
                  Navigate("/login")
                }
              }
            }
          } catch (error) {
            console.error("Error Add Employee in:", error.message);
          }
        }
      }
    } else {
      setErrorText(formErrors);
    }
  };


  const sendMail = async (newUserToken) => {
    const templateParams = {
      to_name: employeeData?.name,
      to_email: employeeData?.company_email,
      date: employeeData.joining_date,
      token: newUserToken,
      subject: `Welcome to Spectus Infotech ${env.subject_mode}`,
      type: "welcome_email",
      from_email: env.basic_email_params.from_email,
    };
    try {
      await axios.post(`${env.backend_api_endpoint}/send-email`, {
        ...templateParams,
      });
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const assignLeave = async (userid) => {
    try {

      const data = {
        compensate_leave: parseFloat(assignObj?.compensate_leave) ? parseFloat(assignObj?.compensate_leave) : Number(0),
        lwp_leave: parseFloat(assignObj?.lwp_leave) ? parseFloat(assignObj?.lwp_leave) : Number(0),
        maternity_leave: parseFloat(assignObj?.maternity_leave) ? parseFloat(assignObj?.maternity_leave) : Number(0),
        paid_leave: parseFloat(assignObj?.paid_leave) ? parseFloat(assignObj?.paid_leave) : Number(0),
        paternity_leave: parseFloat(assignObj?.paternity_leave) ? parseFloat(assignObj?.paternity_leave) : Number(0),
        userId: userid,
      }

      // Encrypt data
      const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

      //Encrypt api endpoint
      const addLeaveSummary = CryptoJS.SHA256("/addLeaveSummary" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(`${env.backend_api_endpoint}/${addLeaveSummary}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        body: JSON.stringify({ encryptedData: encryptedBody }),
      }
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200) {
          let data = {};
          subLeaveArr?.map((val) => {
            let key = val.sub_leave_type_id;
            data = { ...data, [key]: "0" };
          });
          setAssignObj(data);
          toast.success("Employee Add Successfully !", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          navigate("/allemployee");
        }
      }
    } catch (error) {
      console.error("Error Add Leave Summury in:", error.message);
    }
  };

  const leaveHandler = () => {
    if (
      Object.values(employeeData).some((value) => value !== "") ||
      Object.values(errorText).some((value) => value !== "")
    ) {
      setOpen(true);
    } else {
      navigate("/allemployee");
    }
  };

  const handlerBack = () => {
    setOpen(false);
    navigate("/allemployee");
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSalary = (value) => {
    // Convert the value to a number using parseFloat
    const tempvalue = value?.toLocaleString();

    const numericValue = parseFloat(tempvalue.replace(/,/g, ""));
    // Check if the numericValue is a valid number
    if (isNaN(numericValue)) {
      // Handle the case where the value is not a valid number
      return "";
    }
    // Use Intl.NumberFormat to format the number
    return Intl.NumberFormat("en-US").format(numericValue);
  };

  return (
    <LeaveStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{ height: "calc(100vh - 75px)",  padding: "30px 20px" }}
          bordered={false}
          id="add"
          style={{
            margin: 10,
          }}
        >
          <ArrowBackIcon
            onClick={leaveHandler}
            style={{
              fontSize: "22px",
              position: "absolute",
              top: "37px",
              color: "#244DA0",
              cursor: "pointer",
              alignItems: 'center',
              marginTop: '10px',
            }}
          />
          <div
            style={{ display: "flex", marginTop: "3px", paddingLeft: "50px" }}
          >
            <Title
              level={2}
              style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold" }}
            >
              Add Employee
            </Title>
          </div>
          <div className="add-employee-scrollbox">
            <div className="profileItem">
              {/* Name textfeild */}
              <div>
                <Typography className="label_text_profile">
                  Name<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  placeholder="Name"
                  type="text"
                  variant="outlined"
                  error={errorText.name}
                  helperText={errorText.name}
                  onChange={(e) => {
                    setErrorText({
                      ...errorText,
                      name: "",
                    });
                    if (e.target.value !== "") {
                      setEmployeeData({
                        ...employeeData,
                        name: e.target.value,
                      });
                      setErrorText({
                        ...errorText,
                        name: "",
                      });
                    } else {
                      setEmployeeData({
                        ...employeeData,
                        name: "",
                      });
                      setErrorText({
                        ...errorText,
                        name: "Name is required!",
                      });
                    }
                  }}
                  fullWidth
                  size="small"
                />
              </div>
              {/* Email textfeild */}
              <div>
                <Typography className="label_text_profile">
                  Email
                  <span style={{ color: "red" }}>*</span>{" "}
                </Typography>
                <TextField
                  placeholder="Enter Company Email"
                  fullWidth
                  size="small"
                  onChange={(e) => {
                    setErrorText({
                      ...errorText,
                      company_email: "",
                    });
                    if (e.target.value !== "") {
                      setEmployeeData({
                        ...employeeData,
                        company_email: e.target.value,
                      });
                      setErrorText({
                        ...errorText,
                        company_email: "",
                      });
                    } else {
                      setErrorText({
                        ...errorText,
                        company_email: "Email is required!",
                      });
                      setEmployeeData({
                        ...employeeData,
                        company_email: "",
                      });
                    }
                  }}
                  error={errorText.company_email}
                  helperText={errorText.company_email}
                />
              </div>
              {/*Designation textfeild  */}
              <div>
                <Typography className="label_text_profile">
                  Designation<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  placeholder="Enter Designation"
                  fullWidth
                  size="small"
                  onChange={(e) => {
                    setErrorText({
                      ...errorText,
                      designation: "",
                    });
                    if (e.target.value !== "") {
                      setEmployeeData({
                        ...employeeData,
                        designation: e.target.value,
                      });
                      setErrorText({
                        ...errorText,
                        designation: "",
                      });
                    } else {
                      setEmployeeData({
                        ...employeeData,
                        designation: "",
                      });
                      setErrorText({
                        ...errorText,
                        designation: "Please Enter designation!",
                      });
                    }
                  }}
                  error={errorText.designation}
                  helperText={errorText.designation}
                />
              </div>
              {/* Joining Date textfeild */}
              <div>
                <Typography className="label_text_profile ">
                  Joining Date<span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={`Joining ${errorText.joining_date ? "error" : ""
                      }`}
                    defaultValue={
                      employeeData?.joining_date
                        ? dayjs(employeeData?.joining_date)
                        : null
                    }
                    onChange={(e) => {
                      setErrorText({
                        ...errorText,
                        joining_date: "",
                      });
                      setEmployeeData({
                        ...employeeData,
                        joining_date: e.format("YYYY-MM-DD"),
                      });
                    }}
                    fullWidth
                    slotProps={{
                      textField: {
                        size: 'small',
                        InputProps: {
                          sx: {
                            '& .MuiButtonBase-root .MuiSvgIcon-root': {
                              color: '#6B7280',
                              fill: '#6B7280',
                              opacity: 1,
                            },
                          },
                        },
                      },
                    }}
                    style={{ width: "100%" }}
                  />
                </LocalizationProvider>
                <FormHelperText style={{ color: "#d32f2f" }}>
                  {errorText.joining_date}
                </FormHelperText>
              </div>
              {/* Role text */}
              <div>
                <Typography className="label_text_profile">
                  Role<span style={{ color: "red" }}>*</span>
                </Typography>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  sx={{ height: 40 }}
                  placeholder="Select Role"
                  value={selectVal || ""}
                  onChange={(e) => {
                    setErrorText({ ...errorText, role: "" });
                    handleChange(e.target.value);
                  }}
                  fullWidth
                  error={errorText.role}
                  helperText={errorText.role}
                  displayEmpty
                  inputProps={{
                    sx: { color: selectVal ? "black" : "#c4c4c4" },
                  }} // Set the text color
                >
                  <MenuItem value="" disabled>
                    Select Role
                  </MenuItem>
                  {roleData &&
                    roleData.map((role) => (
                      <MenuItem key={role?.id} value={role?.id}>
                        {role?.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText style={{ color: "#d32f2f" }}>
                  {errorText?.role}
                </FormHelperText>
              </div>
              {/* Employee Salary textfeild */}
              <div>
                <Typography className="label_text_profile">
                  Employee Salary<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  placeholder="Enter Salary"
                  fullWidth
                  size="small"
                  type="text"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" color="black">
                        ₹
                      </InputAdornment>
                    ),
                  }}
                  value={
                    employeeData?.salary && handleSalary(employeeData?.salary)
                  }
                  inputProps={{
                    inputMode: "numeric", // Ensures mobile keyboards show numbers
                    pattern: "[0-9]*", // Allows only digits
                    min: 0, // Ensures the value can't be negative
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    setErrorText({
                      ...errorText,
                      salary: "",
                    });
                    if (e.target.value !== "") {
                      setEmployeeData({
                        ...employeeData,
                        salary: e.target.value,
                      });
                      setErrorText({
                        ...errorText,
                        salary: "",
                      });
                    } else {
                      setEmployeeData({
                        ...employeeData,
                        salary: "",
                      });
                      setErrorText({
                        ...errorText,
                        salary: "Please Enter Employee Salary!",
                      });
                    }
                  }}
                  error={errorText.salary}
                  helperText={errorText.salary}
                />
              </div>
              <div>
                <Typography className="label_text_profile">
                  Status <span style={{ color: "red" }}>*</span>
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="radio-buttons-group"
                  defaultValue={employeeData?.flag}

                  onChange={(e) => {
                    setErrorText({
                      ...errorText,
                      flag: "",
                    });
                    setEmployeeData({
                      ...employeeData,
                      flag: e.target.value,
                    });
                  }}
                >
                  <FormControlLabel
                    key="Active"
                    value="Active"
                    control={<Radio
                      sx={{
                        '&.Mui-checked': {
                          color: "#244DA0",
                        },
                      }}
                    />}
                    label="Active"
                  />
                  <FormControlLabel
                    key="Inactive"
                    value="Inactive"
                    control={<Radio
                      sx={{
                        '&.Mui-checked': {
                          color: "#244DA0",
                        },
                      }}
                    />}
                    label="Inactive"
                  />
                </RadioGroup>
                <FormHelperText style={{ color: "#d32f2f" }}>
                  {errorText.flag}
                </FormHelperText>
              </div>
            </div>
            <div className="add_employee_assign_leave_box">
              <div>
                <Title
                  level={4}
                  style={{
                    color: "#244DA0",
                    fontFamily: "ImportedMilliardBold",
                    marginLeft: "20px",
                  }}
                >
                  Assign Leaves
                </Title>
              </div>
              <Grid container spacing={2} className="Leave_item">
                <Grid item xs={4.5} sm={4} lg={4} md={4} xl={4} xxl={4}>
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "16px",
                    }}
                  ></Typography>
                </Grid>
                <Grid
                  item
                  xs={2.5}
                  sm={2.5}
                  lg={2.5}
                  md={2.5}
                  xl={2.5}
                  xxl={2.5}
                  id="Leave_model"
                >
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "14px",
                    }}
                  >
                    Days Assign
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2.5}
                  sm={2.5}
                  lg={2.5}
                  md={2.5}
                  xl={2.5}
                  xxl={2.5}
                  id="Leave_model"
                >
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "14px",
                    }}
                  >
                    Days Taken{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2.5}
                  sm={2.5}
                  lg={2.5}
                  md={2.5}
                  xl={2.5}
                  xxl={2.5}
                  id="Leave_model"
                >
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "14px",
                    }}
                  >
                    Leave Balance
                  </Typography>
                </Grid>
              </Grid>
              {subLeaveArr?.map((val) => {
                let key = val.sub_leave_type_id;
                return (
                  <Grid container spacing={2} className="Leave_item">
                    <Grid item xs={4.5} sm={4} lg={4} md={4} xl={4} xxl={6}>
                      <Typography
                        style={{
                          fontFamily: "ImportedMilliardSemibold",
                          fontSize: "14px",
                        }}
                      >
                        {val?.sub_leave_title}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2.5}
                      sm={2.5}
                      lg={2.5}
                      md={2.5}
                      xl={2.5}
                      xxl={3}
                      id="Leave_model"
                    >
                      <TextField
                        style={{ borderRadius: "5px", maxWidth: "100px" }}
                        type="number"
                        variant="outlined"
                        value={assignObj[key]}
                        defaultValue={0}
                        onChange={(e) => {
                          setAssignObj({ ...assignObj, [key]: e.target.value });
                        }}
                        inputProps={{
                          inputMode: "numeric", // Ensures mobile keyboards show numbers
                          pattern: "[0-9]*", // Allows only digits
                          min: 0, // Ensures the value can't be negative
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onFocus={(e) =>
                          e.target.addEventListener(
                            "wheel",
                            function (e) {
                              e.preventDefault();
                            },
                            { passive: false }
                          )
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2.5}
                      sm={2.5}
                      lg={2.5}
                      md={2.5}
                      xl={2.5}
                      xxl={3}
                      id="Leave_model"
                    >
                      <TextField
                        style={{ borderRadius: "5px", maxWidth: "100px" }}
                        type="number"
                        variant="outlined"
                        value={0}
                        min={0}
                        disabled
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2.5}
                      sm={2.5}
                      lg={2.5}
                      md={2.5}
                      xl={2.5}
                      xxl={2}
                      id="Leave_model"
                    >
                      <TextField
                        style={{ borderRadius: "5px", maxWidth: "100px" }}
                        type="number"
                        variant="outlined"
                        disabled
                        value={assignObj[key]}
                        defaultValue={0}
                        min={0}
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
              }}
            >
              <Button
                size="large"
                variant="contained"
                htmlType="submit"
                onClick={() => onFinish()}
                disabled={preventDoubleClick}
                style={{
                  backgroundColor: "#244DA0",
                  borderRadius: "6px",
                  color: "white",
                  fontWeight: "500",
                  borderColor: "#244DA0",
                  textTransform: "none",
                  height: "fit-content",
                  width: "200px",
                  marginTop: "20px",
                  fontFamily: "MilliardMedium"
                }}
              >
                {preventDoubleClick ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </div>
        </Card>
      </div>
      <Dialog
        open={open}
        onClose={handleCancel}
        style={{ width: "400px", left: "40%" }}
      >
        <DialogContent>
          <center>
            <ErrorIcon style={{ fontSize: "50px" }} />
          </center>
          <p
            style={{
              fontWeight: "600",
              fontSize: "18px",
              textAlign: "center",
              marginTop: "15px",
              color: "rgba(0, 0, 0, 0.66)",
            }}
          >
            Are you sure you want discard your changes?
          </p>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", marginBottom: "10px" }}
        >
          <Button
            block
            size="large"
            key="submit"
            type="primary"
            onClick={handlerBack}
            style={{
              backgroundColor: "#E20E0E",
              borderRadius: "6px",
              fontWeight: "500",
              borderColor: "#E20E0E",
              color: "white",
              width: "120px",
              textTransform: "none",
            }}
          >
            Discard
          </Button>
          <Button
            size="large"
            block
            key="back"
            onClick={handleCancel}
            style={{
              backgroundColor: "#244DA0",
              borderRadius: "6px",
              color: "white",
              fontWeight: "500",
              borderColor: "#244DA0",
              textTransform: "none",
              width: "120px",
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </LeaveStyle>
  );
};

export default AddEmployee;
